export const JOB_TYPES = {
  segmented_hls: 'HLS',
  segmented_dash: 'MPEG-DASH',
  segmented_hds: 'HDS',
  segmented_ss: 'MSS',
  mp4: 'MP4',
  webm: 'WebM',
  mpegts: 'MPEG-TS',
  wvm: 'WMV',
  avi: 'AVI',
  copy: 'copy',
  rtmp: 'RTMP',
};

export const JOB_STATES = {
  processing: 'processing',
  done: 'done',
};

export const INPUT_STATES = {
  pending: 'pending',
  processing: 'processing',
  success: 'success',
  error: 'failed',
};

export const OUTPUT_STATES = {
  pending: 'pending',
  processing: 'processing',
  success: 'finished',
  error: 'failed',
};

export const JOB_EVENTS = {
  'job.create': {
    message() {
      return 'Transcoding task created';
    },
  },
  'job.transc.started': {
    message() {
      return 'Transcoding started';
    },
  },
  'job.transc.processing': {
    message(event) {
      return `Transcoding in the process: ${event.data.progress}%`;
    },
  },
  'job.transc.finished': {
    message() {
      return 'Transcoding completed';
    },
  },
  'job.transc.failed': {
    message() {
      return 'Transcoding failed';
    },
  },
  'job.output.started': {
    message(event) {
      return `Encoding started for output #${event.data.output.index}`;
    },
  },
  'job.output.finished': {
    message(event) {
      return `Upload completed successfully for output #${event.data.output.index}`;
    },
  },
  'job.output.failed': {
    message(event) {
      return `Upload failed for output #${event.data.output.index}`;
    },
  },
  'job.live-transcoder-event': {
    message(event) {
      return `${event.data.description}`;
    },
  },
};

export const DRM = {
  playready: 'PlayReady',
  widevine: 'Widevine',
};

export const AUDIO_CODECS = [
  {
    extId: 'mp3',
    title: 'MP3',
    description: 'A household format. Supported by every media player, web browser, mobile device and TV.',
  },
  {
    extId: 'aac',
    title: 'AAC',
    description: 'A popular format to use. Supported by every media player, web browser, mobile device and TV.',
  },
  {
    extId: 'heaacv2',
    title: 'HE-AAC v2',
    description: 'Only for stereo content. Supported by Flash, HTML5, some mobile devices, but not for iOS.',
  },
  {
    extId: 'vorbis',
    title: 'Vorbis',
    description: 'Not all devices support it natively. Vorbis is compatible vp8 video (webm) and ogg format.',
  },
];

export const VIDEO_CODECS = [
  {
    extId: 'h264',
    title: 'H264',
    description: 'Supported by every player, browser, mobile device and TV.',
  },
  {
    extId: 'h265',
    title: 'H265',
    description: 'Supported by most UHD/4K TVs and connected devices.',
  },
  {
    extId: 'vp8',
    title: 'VP8',
    description: 'Creates a WebM file containing VP8 video. Intended for use in the HTML5 video tag and supported by most browsers.',
  },
  {
    extId: 'xvid',
    title: 'XVID',
    description: 'Intended to compress video to MPEG-4 ASP, a compression standard, to save on disk space and file-transfer speeds.',
  },
];

export const H264_ENCODERS = ['x264', 'Nvidia NVENC', 'Quick Sync'];

export const H265_ENCODERS = ['x265', 'Nvidia NVENC', 'Quick Sync'];

export const VIDEO_CODEC_MAP = {
  h264: ['h264', 'x264', ''],
  h264_qsv: ['h264', 'Quick Sync', ''],
  h264_nvenc: ['h264', 'Nvidia NVENC', ''],
  h265: ['h265', '', 'x265'],
  h265_qsv: ['h265', '', 'Quick Sync'],
  h265_nvenc: ['h265', '', 'Nvidia NVENC'],
  vp8: ['vp8', '', ''],
  xvid: ['xvid', '', ''],
};

export const AUDIO_BITRATES = ['Custom', '64', '96', '128', '160', '192', '256', '512'];

export const AUDIO_CHANNELS_MAP = {
  0: 'Same as source',
  1: 'Mono',
  2: 'Stereo',
};

export const AUDIO_CHANNELS = [
  {
    value: 0,
    title: 'Same as source',
  },
  {
    value: 1,
    title: 'Mono',
  },
  {
    value: 2,
    title: 'Stereo',
  },
];

export const SAMPLE_RATES = ['Same as source', 32000, 44100, 48000];

export const VIDEO_BITRATES = ['Custom', '500', '1000', '1500', '2000', '2500', '3000', '3500', '4000', '5000'];

export const RESOLUTIONS = ['Same as source', 'Custom', 'XGA', 'WXGA', 'HD 720p', 'HD 1080p', 'DCI 2K', '4K UHD', 'DCI 4K'];

export const FRAME_SIZES = {
  XGA: ['1024x768'],
  WXGA: ['1280x800'],
  'HD 720p': ['1280x720', '960x720'],
  'HD 1080p': ['1920x1080', '1440x1080', '1280x1080'],
  'DCI 2K': ['2048x1080'],
  '4K UHD': ['3840x2160'],
  'DCI 4K': ['4096x2160'],
};

export const RESIZE_MODES = ['Same as source', 'Letterbox / Pillarbox', 'Stretch', '16x9'];

export const RESIZE_MODE_MAP = {
  letterboxing: 'Letterbox / Pillarbox',
  stretch: 'Stretch',
  '16x9': '16x9',
};

export const FRAME_RATES = ['Same as source', 'Custom', '23.976', '24', '29.97', '30', '25', '50', '59.94'];

export const KEYFRAME_INTS = ['Auto', 'Custom', 25, 50, 60, 90, 100, 120];

export const H264_CODEC_PROFILES = ['H.264 Baseline', 'H.264 Main Profile', 'H.264 High Profile', 'H.264 High 10 Profile'];

export const H264_CODEC_PROFILE_MAP = {
  baseline: 'H.264 Baseline',
  main: 'H.264 Main Profile',
  high: 'H.264 High Profile',
  high10: 'H.264 High 10 Profile',
};

export const H265_CODEC_PROFILES = ['H.265 Main Profile', 'H.265 Main 10 Profile'];

export const H265_CODEC_PROFILE_MAP = {
  main: 'H.265 Main Profile',
  main10: 'H.265 Main 10 Profile',
};

export const H264_CODEC_LEVELS = ['Auto', '3', '3.1', '3.2', '4', '4.1', '4.2', '5', '5.1'];

export const H265_CODEC_LEVELS = ['Auto', '3', '3.1', '4', '4.1', '5', '5.1', '6', '6.1', '6.2'];

export const H264_REFERENCE_FRAMES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

export const H264_B_FRAMES = [0, 1, 2, 3, 4, 5, 8, 16];

export const ENCODING_FORMATS = [
  {
    extId: 'segmented_hls',
    title: 'HLS',
    description: `<strong>HLS</strong> is a protocol used to stream live video over the internet. Almost every device supports this protocol.
    It will play video encoded with the H.264 or HEVC/H.265 codecs. Video is chopped up into 10-second segments.
    It is an adaptive bitrate protocol. It also can include embedded closed captions, synchronized playback of multiple streams, good support for advertising standards (i.e., VPAID and VAST).
    `,
  },
  {
    extId: 'segmented_dash',
    title: 'MPEG-DASH',
    description: `<strong>DASH</strong> is an open-source standard. Like HLS streaming protocol, DASH is an adaptive bitrate video method.
    It supports advertising, DRM, HTTP delivery, lower-latency streaming, and a number of other features.
    For example, it’s codec agnostic. It supports H.264, HEVC/H.265, VP8, and any other codec you choose to use.
    `,
  },

  {
    extId: 'segmented_ss',
    title: 'MSS',
    description: `<strong>Microsoft Smooth Streaming</strong> is an adaptive video streaming format created by Microsoft and used to stream content through HTTP requests,
    targeting the smooth delivery of HD content to the client.
    MSS can be used for Live streaming but also for Video-On-Demand (VOD) streaming.<br/>
    MSS leverages three different file types for their streaming system which will be described in the following:<br/>
    - Fragmented MP4 files for media content: <i>*.ismv</i> and <i>*.isma</i><br/>
    - Server manifest file: <i>*.ism<br/>
    - Client manifest file: <i>*.ismc</i>
    `,
  },
  {
    extId: 'mpegts',
    title: 'MPEG-TS',
    description: `<strong>MPEG transport stream</strong> is a standard digital container format for transmission and storage of audio, video, and Program and System Information Protocol (PSIP) data.
    It is used in broadcast systems such as DVB, ATSC and IPTV.<br/>
    MPEG-TS is designed for live streaming of events over DVB, UDP multicast, but also over HTTP.
    It divides the stream in elementary streams, which are segmented in small chunks.
    System information is sent at regular intervals, so the receiver can start playing the stream any time.
    MPEG-TS is not as advanced as HLS.
    It does not offer <i>Adaptive Bit Rate</i> control. On the other hand it has excellent compatibility and literally every device on the market supports it.
    `,
  },
  {
    extId: 'mp4',
    title: 'MP4',
    description: `<strong>MP4</strong>, or <strong>MPEG-4</strong>, is an ISO standard file type that's also sometimes referred to with the extension <i>.m4a</i> and <i>.m4p.</i>
    One of the most universal and standardized file formats that exists today. Be used on all kinds of devices, operating systems and by users of many different types.
    The MP4 container format is lossy, and like most of its counterparts is often used for streaming of media files across internet connections.
    `,
  },
  {
    extId: 'webm',
    title: 'WebM',
    description: ` <strong>WebM</strong>, as an open and free Google media format.
    It is one alternative to H.264 standard for high-quality and big advantage on encoding under the same code rate.<br/>
    WebM is a container format (with the file ending <i>*.webm</i>) for multimedia files, i.e. for videos and audio files.
    Within this container, the video codecs VP8 and VP9 and the audio codecs Vorbis and Opus are used.
    WebM is designed for use with HTML5.
    The codecs VP8 and VP9 have been designed in such a way that there is a lot of compression, but that little computer power is required when unzipping the files.
    The aim of this design is to make online video streaming possible on almost any device (such as a desktop, tablet, smartphone or media device such as a smart TV).
    `,
  },
];

export const LIVE_ENCODING_FORMATS = [
  {
    extId: 'segmented_hls',
    title: 'HLS',
  },
  {
    extId: 'segmented_dash',
    title: 'MPEG-DASH',
  },
  {
    extId: 'segmented_ss',
    title: 'MSS',
  },
  {
    extId: 'rtmp',
    title: 'RTMP',
  },
];

export const LANG_CODES = {
  afr: 'Afrikanns',
  sqi: 'Albanian',
  ara: 'Arabic',
  hye: 'Armenian',
  aze: 'Azerbaijani',
  ben: 'Bengali',
  bul: 'Bulgarian',
  cat: 'Catalan',
  zho: 'Chinese (Mandarin)',
  hrv: 'Croation',
  ces: 'Czech',
  dan: 'Danish',
  nld: 'Dutch',
  eng: 'English',
  est: 'Estonian',
  fij: 'Fiji',
  fin: 'Finnish',
  fra: 'French',
  kat: 'Georgian',
  deu: 'German',
  ell: 'Greek',
  guj: 'Gujarati',
  heb: 'Hebrew',
  hin: 'Hindi',
  hun: 'Hungarian',
  isl: 'Icelandic',
  ind: 'Indonesian',
  gle: 'Irish',
  ita: 'Italian',
  jpn: 'Japanese',
  kor: 'Korean',
  lav: 'Latvian',
  lit: 'Lithuanian',
  mkd: 'Macedonian',
  msa: 'Malay',
  mal: 'Malayalam',
  mlt: 'Maltese',
  mri: 'Maori',
  mon: 'Mongolian',
  nep: 'Nepali',
  nor: 'Norwegian',
  fas: 'Persian',
  pol: 'Polish',
  por: 'Portuguese',
  que: 'Quechua',
  ron: 'Romanian',
  rus: 'Russian',
  srp: 'Serbian',
  slk: 'Slovak',
  slv: 'Slovenian',
  spa: 'Spanish',
  swe: 'Swedish ',
  tat: 'Tatar',
  tel: 'Telugu',
  tha: 'Thai',
  bod: 'Tibetan',
  tur: 'Turkish',
  ukr: 'Ukranian',
  urd: 'Urdu',
  uzb: 'Uzbek',
  vie: 'Vietnamese',
  cym: 'Welsh',
  xho: 'Xhosa',
};
